import { render } from "./Widgets.vue?vue&type=template&id=34122458"
import script from "./Widgets.vue?vue&type=script&lang=js"
export * from "./Widgets.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ratul/Code/vue/jourly-admin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__